import { useState } from "react";
import {
    FaCoins,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";
import Config from "../../Config";


function SummaryCards({ summaryData, onClick, user }) {
    const [selectedId, setSelectedId] = useState(null);

    const isOwner =
        user?.userType === Config.USER_TYPE.CLIENT ||
        user?.role === Config.STAFF_ROLES.PARTNER;
    const isAdmin =
        (user?.role === Config.STAFF_ROLES.ADMIN) &&
        user?.userType === Config.USER_TYPE.STAFF;

    const summary = [
        {
            amount: "₹" + summaryData?.total || 0,
            //subTitle: (summaryData?.todayCollection || '0'),
            label: `Total Payments`,
            color: "text-black",
            icon: <FaCoins className="text-green-400" />,
            filter: 'CMT',
        },
        {
            amount: "₹" + summaryData?.totalRent || 0,
            label: `Rent Paid`,
            color: "text-black",
            icon: <FaCoins size={20} className="text-green-400" />,
            filter: 'CMR',
        },
        {
            amount: "₹" + summaryData?.totalSecurity || 0,
            label: `Security Paid`,
            color: "text-black",
            icon: <FaCoins size={20} className="text-green-400" />,
            filter: 'CMS',
        },
        // 👇 Only show if Admin or Client
        ...(isOwner === true || isAdmin === true
            ? [
                {
                    amount: "₹" + (summaryData?.lifetimeSecurity || 0),
                    value: summaryData?.lifetimeSecurity || 0,
                    label: "Total Deposit",
                    filter: "TD",
                },
            ]
            : []),

    ];

    return (
        <Wrapper>
            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {summary.map((item, index) => (
                    <Card
                        key={index}
                        $selected={selectedId === index}
                        className={
                            item.label === "Total Deposit"
                                ? "cursor-default pointer-events-none"
                                : "cursor-pointer"
                        }
                        onClick={() => {
                            if (item.label === "Total Deposit") return;

                            const isSelected = selectedId === index;
                            if (isSelected) {
                                setSelectedId(null);
                                onClick(null);
                            } else {
                                setSelectedId(isSelected ? null : index);
                                onClick(isSelected ? null : item.filter);
                            }
                        }}
                    >
                        <ValueRow>
                            <div className='flex flex-row'>
                                <Value color={item.color}>{item.amount}</Value>
                                {item.subTitle &&
                                    <span className="ml-1 mt-auto text-sm text-gray-600 align-middle mb-1">{"(₹" + item.subTitle + ")"}</span>
                                }
                            </div>
                        </ValueRow>
                        <Label>
                            {item.label}
                            <ArrowWrap className="arrow">
                                <Chevron />
                            </ArrowWrap>
                        </Label>
                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
// const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedid, index }) => selectedid === index ? "shadow-sm shadow-primary-color" : ""}`;
// const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
// const Value = tw.p`
//   text-xl sm:text-2xl font-bold  
//   ${({ color }) =>
//         color}
// `;

const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;

const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default SummaryCards;